exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".choices li .text-wrapper span p{margin:0 !important}.choices li img{min-height:32px}\n", ""]);
